import { DefaultSeo } from "next-seo";
import { FunctionComponent, useMemo } from "react";

import {
  DefaultSEOSchema,
  DefaultSEOSchemaBuilder,
} from "@framework/config/seo.config";
import { CommunityConfig } from "@voxmedia/duet-context/context/config-context";
import { useGlobalDataContext } from "@voxmedia/duet-context/context/global-data-context";

export interface Props {
  schema: DefaultSEOSchema | DefaultSEOSchemaBuilder;
  communityConfig: CommunityConfig;
}

const CommunityDefaultSEO: FunctionComponent<Props> = ({
  schema,
  communityConfig,
}) => {
  const { siteSettings } = useGlobalDataContext();
  const resolvedSEO = useMemo(() => {
    if (typeof schema === "function") {
      return schema(siteSettings, communityConfig);
    } else {
      return schema;
    }
  }, [communityConfig, schema, siteSettings]);

  return <DefaultSeo {...resolvedSEO} />;
};

export default CommunityDefaultSEO;
